// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3BU4g","log":"ModalInventoryLogs_log__FxpX6","date":"ModalInventoryLogs_date__Dubos","userName":"ModalInventoryLogs_userName__22HsU"};